import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M13.0898 1H4.16285C3.16836 1 3.00901 1.06559 3.00901 2.0601L3 17.9399C3 18.9344 3.15938 19 4.15387 19H16.3399C17.3344 19 17.4 18.955 17.4 17.9604V5.22796L13.0898 1ZM13.8 15.4H6.60001V13.6H13.8L13.8 15.4ZM13.8 11.8H6.60001V9.99999H13.8L13.8 11.8ZM12.1898 6.12796V2.35001L16.05 6.12796H12.1898Z",
  fill: "#2ABF7D"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}